<template>
    <input type="text" :placeholder="placeholder" :name="name" v-on:input="$emit('input', $event.target.value)" required>
</template>
<script>
export default{
    props: ["placeholder", "name"]
}

</script>
